/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-props-no-spreading */

import React, { useContext, useEffect, useMemo } from 'react';
import { useQuery, useReactiveVar } from '@apollo/client';
import { DishesSelectionContext } from 'app/containers/contexts/dishesSelection.context';
import { isGlobalLoadingVar } from 'app/apollo/reaction';
import BasketWithCustomization from './BasketWithCustomization/index';
import { BASKET_PAGE_CART_SECTIONS_WITH_DISHES } from './graphql/basketListArea.graphql';

export const makeFlatSection = (sections) => {
    if (!sections) { return []; }

    const flatSections = sections.reduce((acc, section) => [...acc, ...section.items], []);
    return flatSections;
};

export const makePrimetiveSection = (sections) => {
    if (!sections) { return []; }

    const flatSection = makeFlatSection(sections);
    // eslint-disable-next-line no-underscore-dangle
    const primetiveSection = flatSection.map((item) => `${item.__typename}:${item.dish_id}`);
    return primetiveSection;
};

export const getSectionItems = (sections) => {
    if (!sections) {
        return [];
    }
    return sections.reduce((acc, section) => [...acc, ...section.items], []);
};

const BasketListArea = (props) => {
    const {
        handleAddMoreButtonClick,
        handleChangePortion,
        handleRemoveDish,
        onClickMobilePortions,
        mutateItemInCart,
        isCartUpdating,
    } = props;

    const { onOpenSelection } = useContext(DishesSelectionContext);

    const isGlobalLoading = useReactiveVar(isGlobalLoadingVar);

    /* DA */
    const { data } = useQuery(BASKET_PAGE_CART_SECTIONS_WITH_DISHES, {
        fetchPolicy: 'cache-first',
    });

    /* SELECTORS */
    const primetiveSection = useMemo(
        () => makePrimetiveSection(data?.cart?.sections || []),
        [data?.cart?.sections],
    );

    const sectionItems = useMemo(
        () => getSectionItems(data?.cart?.sections || []),
        [data?.cart?.sections],
    );

    useEffect(() => {
        const stForOpen = sessionStorage.getItem('stForOpen');
        if (stForOpen) {
            onOpenSelection({ tag: stForOpen, targetRealm: 'basket' });
            sessionStorage.removeItem('stForOpen');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    /* RENDER */
    return (
        <BasketWithCustomization
            handleAddMoreButtonClick={handleAddMoreButtonClick}
            handleChangePortion={handleChangePortion}
            handleRemoveDish={handleRemoveDish}
            onClickMobilePortions={onClickMobilePortions}
            primetiveSection={primetiveSection}
            sectionItems={sectionItems}
            mutateItemInCart={mutateItemInCart}
            isCartUpdating={isCartUpdating || isGlobalLoading}
            typeOfSet={data?.cart?.typeOfSet}
        />
    );
};

export default React.memo(BasketListArea);

/*

DEPRECATED

const BasketDishesList = (props) => {
    const {
        localeContext: { locale },
        // basketQuery: { cart: { sections } },
        selectedFilters: { selectedPeriod },
        menuDatesContext: { state: menuDatesState },
        invisibleCategories,
        invisibleDishes,
        showAddMoreButton,
        isEditEnabled,
        subscriptionType,
        preparedBasketAreas,
        // ACTIONS
        handleChangePortion,
        handleRemoveDish,
        handleOpenMobileDishDetails,
        handleAddMoreButtonClick,
        onClickMobilePortions,
        sections = { sections },
        // openDishDetails,
    } = props;

    const { data } = useQuery(FETCH_DELIVERY_ADDRESS_SESSION);

    const isSubscriptionActivated = useMemo(
        () => isSubscription(subscriptionType),
        [subscriptionType],
    );

    if (!data) return null;

    const { deliveryAddress: { address: { country_subdivision: subdivision } } } = data;

    return (
        <BasketCategoriesContainer
            subdivision={subdivision}
            preparedBasketAreas={preparedBasketAreas}
            invisibleCategories={invisibleCategories}
            invisibleDishes={invisibleDishes}
            showAddMoreButton={showAddMoreButton}
            isEditEnabled={isEditEnabled}
            isSubscriptionActivated={isSubscriptionActivated}
            categories={sections}
            locale={locale}
            selectedPeriod={selectedPeriod}
            subscriptionType={subscriptionType}
            menuDatesState={menuDatesState}
            // ACTIONS
            onChangePortion={handleChangePortion}
            onClickRemoveDish={handleRemoveDish}
            onClickMobilePortions={onClickMobilePortions}
            onClickMobileDishDetails={handleOpenMobileDishDetails}
            onClickAddMoreButton={handleAddMoreButtonClick}
        />
    );
};


*/
